<template>
  <div class="nlp__what-in-report-box">
    <h2>
      What’s In the <span>Reports</span>
    </h2>
    <div class="nlp__what-in-report-cards">
      <div
        v-for="(item, index) in whatInReportData"
        :key="index"
        class="nlp__what-in-report-card"
      >
        <div class="nlp__what-in-report-card-image">
          <img
            :alt="item.alt"
            :src="item.image"
          >
        </div>
        <div class="nlp__what-in-report-card-info">
          <div class="nlp__what-in-report-card-title">
            {{ item.title }}
          </div>
          <div class="nlp__what-in-report-card-list">
            <div
              v-for="(description, index) in item.description"
              :key="index"
              class="nlp__what-in-report-card-list-item"
            >
              <span>{{ description }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="nlp__what-in-report-card">
        <div class="nlp__what-in-report-card-row">
          <div class="nlp__what-in-report-card-bonus">
            Bonus!
          </div>
          <p>Receive 3 reloads for free. Refresh the report at no extra cost to get the latest updates.</p>
        </div>
      </div>
    </div>
    <div class="nlp__button-box">
      <NlpButton
        primary
        text="Get Report"
        @button-click="$router.push({ name: 'source-of-funds' })"
      />
    </div>
  </div>
</template>

<script>
// Components
import img1 from '@/assets/images/nlp/whatInReportImage1.png'
import img2 from '@/assets/images/nlp/whatInReportImage2.png'
import img3 from '@/assets/images/nlp/whatInReportImage3.png'
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'

export default {
  name: 'NlpWhatInReport',
  components: {
    NlpButton,
  },
  data() {
    return {
      whatInReportData: [
        {
          title: 'Address Risk Check',
          description: ['Know how risky the address is', 'See who owns the address'],
          image: img1,
          alt: 'AML risk score for crypto wallet with high-risk services',
        },
        {
          title: 'Funds Destination Tracker',
          description: ['Follow the money trail', 'Discover where the money is now'],
          image: img2,
          alt: 'Detected darknet exposure in crypto transaction report',
        },
        {
          title: 'Full Checkup',
          description: ['Quickly check the risk and spot the owner', 'See where the money came from and who got it'],
          image: img3,
          alt: 'Detailed crypto wallet risk analysis and funds tracing',
        },
      ],
    }
  },
}
</script>

<style scoped>
.nlp__what-in-report-box h2 {
  margin-bottom: 60px;
}

.nlp__what-in-report-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: auto;
  gap: 16px;
}
.nlp__what-in-report-cards > *:nth-child(1),
.nlp__what-in-report-cards > *:nth-child(4) {
  grid-column: 1 / -1;
}

.nlp__what-in-report-card {
  display: flex;
  flex-direction: column;
  padding: 6px;
  background-color: #FFFFFF;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 81.14%, #F5F5F6 100%);
  outline: 1px solid #E2E9F6;
  border-radius: 24px;
  box-shadow: 2px 2px 4px 0px #B8C2DB40;
}
.nlp__what-in-report-card-image {
  border-radius: 18px;
  overflow: hidden;
}
.nlp__what-in-report-card-image img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.nlp__what-in-report-card-info {
  padding: 24px 36px 36px 36px;
}
.nlp__what-in-report-card-title {
  margin-bottom: 12px;
  font-weight: 900;
  font-size: 28px;
  line-height: 36px;
  color: #1C1C1C;
}
.nlp__what-in-report-card-list-item {
  padding-left: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #5A627D;
}
.nlp__what-in-report-card-list-item:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  margin-right: 8px;
  margin-bottom: 3px;
  background-color: #5A627D;
  border-radius: 100%;
}
.nlp__what-in-report-card-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.nlp__what-in-report-card-bonus {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 8px;
  background: linear-gradient(83.11deg, #194BFB 0.55%, #194BFB 16.37%, #CA0FA2 70.98%, #F1104E 98.1%);
  border: 1px solid #FFFFFF;
  border-radius: 11px;
  box-shadow: 
    0px 1px 1px -0.5px #2A33450A,
    0px 3px 3px -1.5px #2A334614;
  font-weight: 700;
  font-size: 10px;
  line-height: 10px;
  color: #fff;
  text-transform: uppercase;
}
.nlp__what-in-report-card-row p {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
}


.nlp__what-in-report-card:nth-child(1) {
  align-items: center;
  flex-direction: row;
  padding-top: 32px;
}
.nlp__what-in-report-card:nth-child(1) .nlp__what-in-report-card-image {
  order: 2;
  flex: 1 0 60%;
}
.nlp__what-in-report-card:nth-child(1) .nlp__what-in-report-card-info {
  order: 1;
  flex: 1 0 40%;
}
.nlp__what-in-report-card:nth-child(4) {
  padding: 24px;
}


@media (max-width: 1279px) {
  .nlp__what-in-report-card-info {
    padding: 24px 12px 20px 20px;
  }
  .nlp__what-in-report-card-title {
    margin-bottom: 16px;
    font-size: 20px;
    line-height: 28px;
  }
}
@media (max-width: 767px) {
  .nlp__what-in-report-cards {
    display: block;
  }
  .nlp__what-in-report-card {
    display: block;
  }
  .nlp__what-in-report-card + .nlp__what-in-report-card {
    margin-top: 12px;
  }
  .nlp__what-in-report-card-info {
    padding: 24px 12px 20px 12px;
    text-align: center;
  }
  .nlp__what-in-report-card-title {
    margin-bottom: 12px;
  }
  .nlp__what-in-report-card-list-item {
    padding-left: 0;
  }
  .nlp__what-in-report-card-row {
    display: block;
    text-align: center;
  }
  .nlp__what-in-report-card-bonus {
    display: inline-flex;
    margin-bottom: 12px;
  }
}
</style>